import * as React from 'react';

import { usePadding } from '../../utils/paddingFiller';
import { Colors } from '../../utils/types';
import { Box } from '../Layout';
import { Text } from '../Text';

export type TagVariant = 'informational' | 'error' | 'success' | 'additionalSand' | 'additionalBlue' | 'additionalGray';

type TagProps = {
  /** Adds a data-testid attribute to the text of the `<Tag/>` */
  testId?: string;
  /** Changes the background and text color */
  variant?: TagVariant;
  /** Text of the `<Tag/>` */
  text: string;
  /** Size of tag, changes padding and font size */
  size?: 'small' | 'large';
  /** Add white border */
  hasWhiteOutline?: boolean;
};

export const Tag = ({ testId, variant = 'informational', text, size = 'small', hasWhiteOutline = false }: TagProps) => {
  const p = usePadding(size === 'small' ? { desktop: [3, 12, 3, 12] } : { desktop: [4, 12, 4, 12] });

  return (
    <Box
      {...p}
      backgroundColor={colorMap[variant].bg}
      borderRadius="3px"
      display="inline-block"
      border={hasWhiteOutline ? '1px solid #FFF' : ''}
    >
      <Text
        whiteSpace="nowrap"
        style={{ fontSize: size === 'large' ? '16px' : '14px' }}
        testId={testId}
        renderAs="span"
        color={colorMap[variant].text}
      >
        {text}
      </Text>
    </Box>
  );
};

const colorMap: { [key in TagVariant]: { bg: Colors; text: Colors } } = {
  informational: { bg: 'babyYellow', text: 'burgundyDark' },
  error: { bg: 'babyPink', text: 'burgundy' },
  success: { bg: 'babyGreen', text: 'petroleumGreen' },
  additionalSand: { bg: 'sand', text: 'burgundyDark' },
  additionalBlue: { bg: 'babyBlue', text: 'shadowDarkBlue' },
  additionalGray: { bg: 'black20', text: 'black90' },
};
